import { Ng2StateDeclaration } from '@uirouter/angular';
import * as fromIndirectRate from '.';
import { RatePlanningFeatureComponent } from '../rate-planning/rate-planning-feature/rate-planning-feature.component';
import { LoggingService } from '../shared/services/logging/logging.service';

const log = new LoggingService();

export const IndirectRateRoute: Ng2StateDeclaration = {
    // name: 'indirectrate.**'
    name: 'indirect.rate',
    // url: '/indirect/rate',
    url: '/rate',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.IndirectRateModule)
    data: { requiresAuth: true },
    component: fromIndirectRate.IndirectRateContainerComponent
};
export const IndirectRateManagementRoute: Ng2StateDeclaration = {
    // name: 'indirectrate.**'
    name: 'indirect.management',
    // url: '/indirect/rate',
    url: '/management',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.IndirectRateModule)
    data: { requiresAuth: true },
    component: fromIndirectRate.IndirectRateManagementContainerComponent
};
export const IndirectRateHistoryRoute: Ng2StateDeclaration = {
    // name: 'indirectrate.**'
    name: 'indirect.history',
    // url: '/indirect/rate',
    url: '/history',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.IndirectRateModule)
    data: { requiresAuth: true },
    component: fromIndirectRate.IndirectRateHistoryContainerComponent
};

export const RatePlanningRoute: Ng2StateDeclaration = {
    name: 'indirect.rateplanning',
    url: '/rateplanning',
    data: { requiresAuth: true },
    component: RatePlanningFeatureComponent
};
